import Image from 'next/image';
import Link from 'next/link';

interface LogoProps {
  className?: string;
  linkToHome?: boolean;
  variant?: 'default' | 'white' | 'bright' | 'dark';
  /**
   * Fixed rendered size in px. Pass BOTH to pin the wordmark (the app home
   * does): the element then gets exactly these dimensions instead of the
   * default "auto height, width from the layout", which lets the asset grow
   * to its intrinsic size when the container is wide.
   */
  width?: number;
  height?: number;
}

export function Logo({
  className = '',
  linkToHome = false,
  variant = 'default',
  width,
  height,
}: LogoProps) {
  // `dark` is the dark-theme wordmark (Teal400 #0AC2B9) — same tint the Apple
  // and Android apps use for the brand mark on a dark page.
  const src =
    variant === 'white'
      ? '/logo-text-white.svg'
      : variant === 'bright'
        ? '/logo-text-bright.svg'
        : variant === 'dark'
          ? '/logo-text-dark.svg'
          : '/logo-text.svg';
  const isFixed = width !== undefined && height !== undefined;
  const logoElement = (
    <Image
      src={src}
      alt="GetFacade"
      width={width ?? 164}
      height={height ?? 24}
      priority
      className={className}
      style={isFixed ? { width, height } : { height: 'auto' }}
    />
  );

  if (linkToHome) {
    return (
      <Link href="/" className="inline-block">
        {logoElement}
      </Link>
    );
  }

  return logoElement;
}
